
import { Vue, Component } from "vue-property-decorator";
import CardWrapper from "./card-wrapper.vue";
import RuleFormItem from "./rule-form-item.vue";
import {
  CustomRule,
  ExecRule
} from "@/lib/model/exambuilder/exam-component/application-rule";
import { cloneDeep } from "lodash-es";

@Component({
  components: {
    CardWrapper,
    RuleFormItem
  }
})
export default class CustomRuleForm extends Vue {
  private visible = false;
  private title = "";
  private idx: number | undefined = undefined;
  private formData = new CustomRule().assign({
    execRuleList: [{ type: "", tagName: "" }]
  });
  private ruleList = [
    { type: "tag", tagName: "打标签", active: false },
    { type: "reportMessage", tagName: "报告自定义标签", active: false }
  ];

  add(params?: CustomRule) {
    this.title = "添加应用规则";
    this.idx = undefined;
    if (params) {
      this.formData = cloneDeep(params);
      console.log(this.formData);
    }
    this.visible = true;
  }

  edit(params: CustomRule, idx: number) {
    this.title = "编辑应用规则";
    this.formData = cloneDeep(params);
    this.idx = idx;
    this.visible = true;
  }

  private reset() {
    this.formData = new CustomRule().assign({
      execRuleList: [{ type: "", tagName: "" }]
    });
  }

  private beforeClose() {
    this.reset();
    this.$nextTick(() => {
      (this.$refs.form as any).clearValidate();
    });
    this.visible = false;
  }

  private handleAdd() {
    this.formData.matchRule.matchNode.subList?.push({
      mergeType: "AND",
      subList: [{ detail: {} }]
    });
  }

  handleAddOr() {
    this.formData.matchRule.matchNode.subList?.push({
      detail: {}
    });
  }
  private handleAddAction() {
    this.formData.execRuleList.push(new ExecRule());
  }

  private handleSubmit() {
    (this.$refs.form as any).validate((valid: boolean) => {
      if (!valid) return false;
      if (!this.formData.execRuleList.length) {
        this.$message.error("请至少添加一个动作");
        return false;
      }
      this.$emit("success", this.formData, this.idx);
      this.beforeClose();
    });
  }

  private handleMouseEnter(e: MouseEvent) {
    if (this.formData.matchRule.matchNode.subList!.length <= 1) return;
    (e.target as HTMLElement).classList.add("err-active");
  }

  private handleMouseLeave(e: MouseEvent) {
    (e.target as HTMLElement).classList.remove("err-active");
  }
}
